import React from "react";

export default class BackgroundSlider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            currentArticle: null,
            currentIndex: 0,
            translateValue: 0,
            autoplay: true
        }

        this.sliderId = this.generateId();
    }

    generateId = () => {
        return '_' + Math.random().toString(36).substr(2, 9);
    };

    goToPrevSlide = () => {
        if(this.state.currentIndex === 0) {
        	this.setState({
                currentIndex: this.props.slides.length - 1,
                translateValue: -(this.slideWidth() * (this.props.slides.length - 1)),
            });
            return this.props.slides.length - 1;
        }

        this.setState(prevState => ({
            currentIndex: prevState.currentIndex - 1,
            translateValue: prevState.translateValue + this.slideWidth()
        }))
        return this.state.currentIndex - 1;
    }

    goToNextSlide = () => {
        if(this.state.currentIndex === this.props.slides.length - 1) {
        	this.setState({
                currentIndex: 0,
                translateValue: 0,
            });
            return 0;
        }

        this.setState(prevState => ({
            currentIndex: prevState.currentIndex + 1,
            translateValue: prevState.translateValue + -(this.slideWidth())
        }));
        return this.state.currentIndex + 1;
    }

    goToSlide = slide => {
        this.setState(prevState => ({
            currentIndex: slide,
            translateValue: prevState.translateValue + (this.slideWidth() * (prevState.currentIndex - slide)),
        }));
    }

    slideWidth = () => {
        return document.querySelector('#slider_'+this.sliderId).clientWidth
    }


    render() {
        return <div id={"slider_"+this.sliderId} className="slider">

            <div className="slider-wrapper"
                 style={{
                     transform: `translateX(${this.state.translateValue}px)`,
                     transition: 'transform ease-out 0.45s'
                 }}>
                {
                    this.props.slides.map((slide, i) => (
                        <Slide key={i} image={slide.resource.url} className={this.props.filterImage} />
                    ))
                }
            </div>
        </div>
	}

}


const Slide = ({ image, className }) => {
    const styles = {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 60%'
    }
    if(image) styles["backgroundImage"] = `url(${image})`;
    return <div className={`slide ${className}`} style={styles}></div>
}